import { twMerge } from "tailwind-merge";
import { IFaqContent, IFaqDataProps } from "../../interfaces/Faq.interface";
import FaqAccordion from "./FaqAccordion";

export interface FAQProps {
  content: IFaqContent;
  faqData?: IFaqDataProps;
}

export default async function FAQ({ content, faqData }: FAQProps) {
  return (
    <section id={content?.componentLink} className={twMerge(faqData ? "" : "px-[16px] py-[12px]", content?.customClass ?? "")}>
      <h2 className="text-[18px] font-medium leading-[23.7px] text-[#000000]">
        {content?.faqTitle}
      </h2>
      {content?.accordianDetails?.[0] && (
        <FaqAccordion
          faqData={faqData}
          content={content?.accordianDetails?.[0] ?? []}
          desktopFaqCount={content?.desktopFaqCount}
          mobileFaqCount={content?.mobileFaqCount}
          showLessText={content?.showLess}
          showMoreText={content.showMore}
        />
      )}
    </section>
  );
}
